import { render, staticRenderFns } from "./ForeCastReport.vue?vue&type=template&id=bc8a75f4&scoped=true&"
import script from "./ForeCastReport.vue?vue&type=script&lang=js&"
export * from "./ForeCastReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8a75f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8a75f4')) {
      api.createRecord('bc8a75f4', component.options)
    } else {
      api.reload('bc8a75f4', component.options)
    }
    module.hot.accept("./ForeCastReport.vue?vue&type=template&id=bc8a75f4&scoped=true&", function () {
      api.rerender('bc8a75f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/ForeCastReport.vue"
export default component.exports